import SoldProducts from './SoldProducts';

export default SoldProducts;
